import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@src/environments/environment';
import { UtilsService } from './utils.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const apiBaseUrl = environment.config.TRACKING_SERVICE_URL;
  if (req.url.startsWith(apiBaseUrl)) {
    let headers = req.headers.set(
      'Authorization',
      `Bearer ${UtilsService.getUserToken() ?? ''}`
    );
    if (req.body instanceof FormData) {
      headers = headers.set('enctype', 'multipart/form-data');
    } else {
      if (!req.headers.has('Content-Type')) {
        headers = headers.set('Content-Type', 'application/json');
      }
    }
    const modifiedReq = req.clone({ headers });
    return next(modifiedReq);
  }

  return next(req);
};
